export const formatCurrency = (amount: number, minFractionDigits?: number, maxFractionDigits?: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minFractionDigits ?? 2,
    maximumFractionDigits: maxFractionDigits ?? 2
  })

  return formatter.format(amount)
}

export const formatNumber = (value: number, minFractionDigits?: number, maxFractionDigits?: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minFractionDigits ?? 2,
    maximumFractionDigits: maxFractionDigits ?? 2
  })

  return formatter.format(value)
}

export const formatPercentage = (value: number, minFractionDigits?: number, maxFractionDigits?: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: minFractionDigits ?? 2,
    maximumFractionDigits: maxFractionDigits ?? 2
  })

  return formatter.format(value)
}

export const formatPhoneNumber = (phoneNumber: string) => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '')
  const match = cleaned.match(/(\d{3})(\d{3})(\d{4})/)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  return phoneNumber
}
